/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { alpha, Box, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import type { ReactNode } from 'react';

/** One row of the avatar menu: icon, label and an optional shortcut chip or badge. */
export const UserMenuItem = ({
  icon,
  label,
  shortcut,
  badge,
  danger = false,
  onClick,
}: Readonly<{
  icon: ReactNode;
  label: string;
  shortcut?: string;
  badge?: string;
  danger?: boolean;
  onClick: () => void;
}>) => (
  <MenuItem
    onClick={onClick}
    sx={{
      minHeight: 32,
      mx: 0.75,
      px: 1.25,
      py: 0.75,
      borderRadius: '8px',
      color: danger ? 'error.main' : 'text.primary',
      '& .MuiListItemIcon-root': {
        minWidth: 26,
        color: danger ? 'inherit' : 'text.secondary',
        '& svg': { fontSize: 16 },
      },
    }}
  >
    <ListItemIcon>{icon}</ListItemIcon>
    <ListItemText
      sx={{ my: 0 }}
      slotProps={{ primary: { sx: { fontSize: 13, fontWeight: 500 } } }}
      primary={label}
    />
    {shortcut && (
      <Box
        component="kbd"
        sx={(theme) => ({
          px: 0.75,
          py: 0.125,
          borderRadius: '6px',
          border: `1px solid ${theme.palette.divider}`,
          bgcolor: alpha(theme.palette.background.default, 0.6),
          color: 'text.secondary',
          fontFamily: 'inherit',
          fontSize: 10,
          fontWeight: 500,
          lineHeight: 1.6,
        })}
      >
        {shortcut}
      </Box>
    )}
    {badge && (
      <Box
        sx={(theme) => ({
          px: 0.875,
          borderRadius: 999,
          border: `1px solid ${alpha(theme.palette.warning.main, 0.6)}`,
          color: 'warning.main',
          fontSize: 10,
          fontWeight: 600,
          lineHeight: 1.6,
        })}
      >
        {badge}
      </Box>
    )}
  </MenuItem>
);
